const STORE_KEY = 'location';

export const selectLocationState = state => state[STORE_KEY];
export const selectParams = state => selectLocationState(state).payload;
export const selectQuery = state => selectLocationState(state).query || {};



// WEBPACK FOOTER //
// ./src/store/reducers/location.selectors.js